// ---------------------------------------------------------------------------
// process_type — ระบบหน้าบ้านที่เป็นคนสร้าง order เข้ามาที่ PaymentBroker
// ---------------------------------------------------------------------------
// ค่านี้ถูกส่งมากับ order ตอนเรียก transactions/deposits/partner
// ใช้ที่ badge ของหน้า Order Marketplace และใช้เป็น
// ตัวเลือกของฟิลเตอร์ Process Type
//
// เพิ่มระบบใหม่: เติมรายการใน PROCESS_TYPES รายการเดียว ทั้ง badge และฟิลเตอร์
// จะได้ค่าใหม่พร้อมกัน
// ---------------------------------------------------------------------------

export const PROCESS_TYPES = [
  // --- ต่อ payment แล้ว ---
  {
    value: "zenith_market",
    label: "Zenith Market",
    icon: "\uf07a", // shopping-cart
    background: "#eef6ff",
    color: "#0d6efd",
    border: "1px solid #cfe2ff",
  },
  {
    value: "lucid_topup",
    label: "LucidTopup",
    icon: "\uf11b", // gamepad
    background: "#f3eefe",
    color: "#7c3aed",
    border: "1px solid #e0d4fb",
  },
  {
    value: "levelup_crm",
    label: "LevelUpCRM",
    icon: "\uf0c0", // users
    background: "#fff8e5",
    color: "#b45309",
    border: "1px solid #fde9b8",
  },
  {
    value: "lucid_crm",
    label: "LucidCRM",
    icon: "\uf007", // user
    background: "#e8f1ff",
    color: "#1d4ed8",
    border: "1px solid #c7dbff",
  },
  {
    value: "aitalk",
    label: "AITalk",
    icon: "", // comments
    background: "#ecfeff",
    color: "#0e7490",
    border: "1px solid #bae6fd",
  },
  {
    value: "mixai",
    label: "MixAI",
    icon: "", // magic
    background: "#fef2f2",
    color: "#b91c1c",
    border: "1px solid #fecaca",
  },
  {
    value: "zenithlink_aitalk",
    label: "Zenithlink AITalk",
    icon: "", // comments
    background: "#f0fdfa",
    color: "#0f766e",
    border: "1px solid #99f6e4",
  },
  {
    value: "zenithlink_mixai",
    label: "Zenithlink MixAI",
    icon: "", // magic
    background: "#fff1f2",
    color: "#be123c",
    border: "1px solid #fecdd3",
  },

  // --- จองค่าไว้ล่วงหน้า ยังไม่ต่อ payment ---
  {
    value: "levelup_one",
    label: "LevelUp One",
    icon: "\uf0e7", // bolt
    background: "#fdf2f8",
    color: "#be185d",
    border: "1px solid #fbd0e3",
  },
  {
    value: "levelup_topup",
    label: "LevelUp Topup",
    icon: "\uf51e", // coins
    background: "#fff7ed",
    color: "#c2410c",
    border: "1px solid #fed7aa",
  },
  {
    value: "swift_game_pay",
    label: "SwiftGamePay",
    icon: "\uf091", // trophy
    background: "#ecfdf5",
    color: "#047857",
    border: "1px solid #bbf7d0",
  },
  {
    value: "zenith_link",
    label: "ZenithLink",
    icon: "\uf0c1", // link
    background: "#f1f5f9",
    color: "#334155",
    border: "1px solid #d8e0ea",
  },
];

export const PROCESS_TYPE_MAP = PROCESS_TYPES.reduce((acc, item) => {
  acc[item.value] = item;
  return acc;
}, {});

/** ค่าที่ใช้เมื่อ order ไม่ได้ส่ง process_type มา (ข้อมูลเก่าก่อนมีฟิลด์นี้) */
export const DEFAULT_PROCESS_TYPE = "zenith_market";

/**
 * สไตล์ badge ของ process_type
 * ค่าที่ไม่รู้จัก (ระบบใหม่ที่ยังไม่ได้เพิ่มในลิสต์) จะโชว์ชื่อค่าดิบแทนที่จะหาย
 */
export const processTypeStyle = (value) =>
  PROCESS_TYPE_MAP[value] || {
    value,
    label: value,
    icon: "\uf07a",
    background: "#eef6ff",
    color: "#0d6efd",
    border: "1px solid #cfe2ff",
  };

/** ตัวเลือกของฟิลเตอร์ Process Type (ตัวแรก = ไม่กรอง) */
export const PROCESS_TYPE_OPTIONS = [
  { value: "", label: "Process Type" },
  ...PROCESS_TYPES.map((item) => ({ value: item.value, label: item.label })),
];
